export default __webpack_public_path__ + "img/homePage.20c0b676.png";